export const DcPriceListColDef = [
  {
    headerClass: "primary",
    colId: "Warehouse",
    field: "Warehouse",
    width: "fit-content",
    // enableRowGroup: true,
    // enablePivot: true,
    width: 140,
    pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerClass: "primary",
    colId: "Category",
    field: "Category",
    width: 130,
    pinned: true,
    filter: "text",
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerName: "Product Name",
    headerClass: "primary",
    colId: "Product_Name",
    field: "Product_Name",
    width: 160,
    // enableRowGroup: true,
    // enablePivot: true,
    pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerName: "ProductCode",
    headerClass: "primary",
    colId: "ProductCode",
    field: "ProductCode",
    width: 120,
    // enableRowGroup: true,
    // enablePivot: true,
    pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerClass: "primary",
    headerName: "MRP",
    field: "MRP",
    width: 100,
    filter: "text",
    cellRenderer: "agGroupCellRenderer",
    valueFormatter: (params) => {
      return params.value ? params.value.toFixed(2) : "0";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "Retailer Margin %",
    colId: "Retailer_Margin",
    field: "Retailer_Margin",
    filter: "text",
    width: 180,
    // cellRenderer: "agGroupCellRenderer",
    cellRenderer: (params) => {
      return params.value ? `${(params.value * 100).toFixed(2)} %` : "0%";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "PTR",
    colId: "PTR",
    field: "PTR",
    filter: "text",
    width: 100,
    valueFormatter: (params) => {
      return params.value ? params.value.toFixed(2) : "0";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "Tax %",
    colId: "Tax",
    field: "Tax",
    filter: "text",
    width: 110,
     cellRenderer: (params) => {
      return params.value ? `${params.value * 100} %` : "0%";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "Net PTR",
    colId: "Net_PTR",
    field: "Net_PTR",
    filter: "text",
    width: 120,
    valueFormatter: (params) => {
      return params.value ? params.value.toFixed(2) : "0";
    },
    type: "rightAligned",
  },

  {
    headerClass: "primary",
    headerName: "From Date",
    colId: "From_Date",
    field: "From_Date",
    width: 140,
    // enableRowGroup: true,
    // enablePivot: true,
    filter: "text",
    // hide: true,
    valueFormatter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      if (isNaN(date)) return "";
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${date.getFullYear()}`;
    },
  },

  {
    headerClass: "primary",
    headerName: "To Date",
    colId: "To_Date",
    field: "To_Date",
    width: 120,
    // enableRowGroup: true,
    // enablePivot: true,
    filter: "text",
    // hide: true,
    valueFormatter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      if (isNaN(date)) return "";
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${date.getFullYear()}`;
    },
  },
];
